<script setup lang="ts">
  import { computed } from 'vue';
  import { KEBAB_OPTIONS } from '@/entities/Document';
  import MenuKebabIcon from '@/shared/assets/icons/menuKebabIcon.svg';
  import { ActionMenu, IconImage } from '@/shared/ui';

  const props = defineProps<{
    modelValue?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', v: boolean): void;
    (e: 'select', id: string): void;
  }>();

  const menuItems = computed(() =>
    KEBAB_OPTIONS.map((option) => ({
      id: option.id,
      label: option.name,
      onClick: () => emit('select', option.id),
    }))
  );
</script>

<template>
  <ActionMenu
    :items="menuItems"
    :model-value="props.modelValue"
    :stop-trigger-click-propagation="true"
    menu-class="absolute right-0 mt-2 w-56 rounded-xl border border-gray-200 bg-white-01 shadow-xl ring-0 p-2 z-50"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #trigger="{ isOpen }">
      <button
        type="button"
        class="inline-flex items-center justify-center p-1 text-[var(--theme-secondary-ink)] hover:opacity-80 bg-transparent border-0 rounded-none focus:outline-none focus:ring-0 focus-visible:ring-2 focus-visible:ring-[var(--theme-secondary-ink)]"
        aria-label="Abrir menu"
        aria-haspopup="menu"
        :aria-expanded="isOpen"
      >
        <IconImage
          :src="MenuKebabIcon"
          alt=""
          class="h-5 w-5 select-none"
          draggable="false"
        />
      </button>
    </template>
  </ActionMenu>
</template>

<style scoped>
  :host,
  .relative {
    overflow: visible;
  }
</style>
